import auth from "@/auth.js";

export default {
  [auth.roles.USER]: [
    {
      title: "CRM",
      action: "folder",
      subItems: [
        { text: "Співробітники", routeName: "crmEmployees" },
        { text: "Завдання", routeName: "crmTasks" },
        { text: "Компанії", routeName: "crmCompanies" },
        { text: "Контакти", routeName: "crmContacts" },
        { text: "Валюти", routeName: "crmCurrencies" },
        { text: "Угоди", routeName: "crmAgreements" },
        { text: "Типи воронок продажів", routeName: "crmSalesFunnelTypes" },
        { text: "Стадії воронок продажів", routeName: "crmSalesFunnelStages" },
      ],
    },
  ],
  [auth.roles.ADMINISTRATOR]: [
    {
      title: "CRM",
      action: "folder",
      subItems: [
        { text: "Співробітники", routeName: "crmEmployees" },
        { text: "Завдання", routeName: "crmTasks" },
        { text: "Компанії", routeName: "crmCompanies" },
        { text: "Контакти", routeName: "crmContacts" },
        { text: "Валюти", routeName: "crmCurrencies" },
        { text: "Угоди", routeName: "crmAgreements" },
        { text: "Типи воронок продажів", routeName: "crmSalesFunnelTypes" },
        { text: "Стадії воронок продажів", routeName: "crmSalesFunnelStages" },
      ],
    },
  ],
  [auth.roles.SALES_MANAGER]: [],
  [auth.roles.ACCOUNT_MANAGER]: [],
  [auth.roles.ACCOUNT_CLIENT]: [],
};